import { IPriceSnapshotData, ICustomerPricingData } from '@/models';
import {
  IPriceSnapshotPaginatedListData,
  IPriceSnapshotService
} from './pricesnapshot.types';
import { AxiosInstance } from 'axios';

export class PriceSnapshotService implements IPriceSnapshotService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/csi/items/snapshots/';
  }

  fetchPriceSnapshots(
    page: number,
    search?: string
  ): Promise<IPriceSnapshotPaginatedListData> {
    return this.axios
      .get<IPriceSnapshotPaginatedListData>(`${this.endpoint}`, {
        params: { page, search }
      })
      .then(({ data }) => data);
  }

  fetchPriceSnapshot(id: number): Promise<IPriceSnapshotData> {
    return this.axios
      .get<IPriceSnapshotData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createPriceSnapshot(data: IPriceSnapshotData): Promise<IPriceSnapshotData> {
    return this.axios
      .post<IPriceSnapshotData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updatePriceSnapshot(data: IPriceSnapshotData): Promise<IPriceSnapshotData> {
    return this.axios
      .patch<IPriceSnapshotData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deletePriceSnapshot(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  assignCustomerSnapshot(data: ICustomerPricingData): Promise<any> {
    return this.axios.post(`${this.endpoint}${data.snapshot}/add_customer/`, {
      customer: data.customer,
      validity: data.validity
    });
  }
}
